export default __webpack_public_path__ + "static/media/CTOactiveTab.789daed6.svg";